import type { MapProps } from '@vis.gl/react-google-maps';

/**
 * Shared Google Map UI options so EVERY embedded map across the suite exposes
 * the same controls — the Map/Satellite type toggle + zoom, cooperative
 * gesture handling, and none of the other default clutter. Spread into every
 * `<Map>` (see `AddressInlineEditor` and the TMS `BookingMap`) rather than
 * setting the flags per-map, so the option set can't drift screen-to-screen.
 */
export const MAP_DEFAULT_PROPS: Pick<
  MapProps,
  'gestureHandling' | 'disableDefaultUI' | 'zoomControl' | 'mapTypeControl'
> = {
  gestureHandling: 'cooperative',
  disableDefaultUI: true,
  zoomControl: true,
  mapTypeControl: true,
};
